import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import type { RootState } from "@/redux/store";

/**
 * Gates the Platform Owner area on the platform_role claim / active support-session state
 * carried on the user object (see authSlice.User.scope/platformRoles/isPlatformSupportSession),
 * not on a tenant role string — platform authority is never derived from a tenant role.
 */
export function PlatformOwnerRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth?.isAuthenticated ?? false,
  );
  const user = useSelector((state: RootState) => state.auth?.user ?? null);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const allowed = user?.scope === "PLATFORM" || user?.isPlatformSupportSession === true;
  if (!allowed) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
